import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import translations_en from "crqlar-react-common/dist/translations/en.json"
import translations_de from "crqlar-react-common/dist/translations/de.json"
import translations_it from "crqlar-react-common/dist/translations/it.json"
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    en: {
        translation: translations_en
    },
    de: {
        translation: translations_de
    },
    it: {
        translation: translations_it
    }
};

const initLocalization = async () => {
    await i18n
        .use(initReactI18next)
        .use(LanguageDetector)
        .init({
            resources,
            fallbackLng: "en",
            supportedLngs: ['en', 'de', 'it'],

            keySeparator: false,

            interpolation: {
                escapeValue: false
            }
        });
}

export default initLocalization;
